module.exports = __webpack_public_path__ + "img/p61.9eaa7cfd.jpg";